import { Box } from '@mui/material';
import { getIconComponent } from 'components/lineage/Icons';

export type SourceType = 'powerbi' | 'tableau' | 'dataset' | 'domain';

const PLUGIN_NAME: Record<SourceType, string> = {
    powerbi: 'powerbi',
    tableau: 'tableau',
    dataset: 'metric-insights',
    domain: 'metric-insights',
};

interface Props {
    sourceType: SourceType;
    size?: number;
}

export default function SourceTypeIcon({ sourceType, size = 16 }: Props) {
    return (
        <Box sx={{ width: size, height: size, flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            {getIconComponent(PLUGIN_NAME[sourceType] ?? PLUGIN_NAME.dataset)}
        </Box>
    );
}
